import React, { useContext } from 'react';
import SavedFiltersUsageLookupContext from '../../context/SavedFiltersUsageLookupContext';
import ReportUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/ReportUsage';
import DashboardGadgetUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/DashboardGadgetUsage';
import ScorecardUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/ScorecardUsage';
import GoalsUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/Goals';
import ChartDefinitionUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/ChartDefinitionUsage';
import BoardsUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/BoardsUsage';
import CompoundMetricsUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/CompoundMetricsUsage';
import PerformanceUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/PerformanceUsage';
import MetricsUsage from 'screens/DataManager/Metrics/MetricSlideOut/UsageTab/MetricsUsage';

const UsageTab = ({ filter }: { filter: SavedFilter }) => {
  const { savedFiltersLookup } = useContext(SavedFiltersUsageLookupContext);
  const usageReport = savedFiltersLookup[filter.id];

  if (!usageReport) {
    return null;
  }

  const {
    chartDefinitions,
    reports,
    scorecards,
    goals,
    boards,
    dashboardGadgets,
    compoundMetrics,
    metrics,
    performanceConfigurations,
  } = usageReport;

  return (
    <div>
      <ReportUsage reports={reports} usedId={filter.id} />
      <DashboardGadgetUsage
        dashboardGadgets={dashboardGadgets}
        usedId={filter.id}
      />
      <ScorecardUsage scorecards={scorecards} usedId={filter.id} />
      <GoalsUsage goals={goals} usedId={filter.id} />
      <ChartDefinitionUsage
        chartDefinitions={chartDefinitions}
        usedId={filter.id}
      />
      <BoardsUsage boards={boards} usedId={filter.id} />
      <MetricsUsage metrics={metrics} usedId={filter.id} />
      <CompoundMetricsUsage
        compoundMetrics={compoundMetrics}
        usedId={filter.id}
      />
      <PerformanceUsage
        performanceConfigs={performanceConfigurations}
        usedId={filter.id}
      />
    </div>
  );
};

export default UsageTab;
